import sendRequest from "../fetch"
import api from '../url'

const _base = "jwGraduatePhoto/";

// 毕业档案相片 - 获取详情
export const getGraduatePhoto = () => {
  return sendRequest(api.url + _base + "view", {
    method: "GET",
  });
};

// 毕业档案相片 - 上传
export const uploadGraduatePhoto = (params) => {
  return sendRequest(api.url + _base + "upload", {
    data: params,
    method: "POST",
  });
};



// WEBPACK FOOTER //
// ./src/fetch/api/graduatePhoto.js